import * as yup from 'yup';
import moment from 'moment';
import {usernameAvailability} from './lyfshortService';

export const userSchema = yup.object().shape({
    firstName: yup.string().when(
        '$isNameOptional',
        ([isNameOptional], schema) => (
            isNameOptional ? schema : schema.required()
        )
    ),
    lastName: yup.string().when(
        '$isNameOptional',
        ([isNameOptional], schema) => (
            isNameOptional ? schema : schema.required()
        )
    ),
    email: yup.string().email().required(),
    username: yup.string().min(1).max(50).matches(
        /^[a-zA-Z0-9\-_]+$/,
        'must only contain letters A-Z, numbers 0-9, underscore _, or dash -'
    )
    .when(
      '$allocatedUsername',
      (allocatedUsername, schema) => {
        if (!allocatedUsername?.[0]) {
          return schema;
        }
        return schema.test(
          'is-available',
          'This username is already in use',
          async function (value = '', context) {
            if (value === allocatedUsername[0]) {
              return true;
            }
            try {
              const result = await usernameAvailability(value);
              return result.available;
            } catch(error) {
              throw context.createError({
                path: context.path,
                message: 'Error finding out if username is available',
              });
            }
          }
        );
      }
    )
    .required(),
    homeLocationCountry: yup.string().required().label('Country'),
    sex: yup.string().label('Gender'),
    birthDate: yup.date().max(moment().subtract(13,'years').startOf('day').toDate()).required(),
});

export const userWithPasswordSchema = userSchema.shape({
  password: yup.string().required(),
});
